import { Component, ViewChild, Injector, Output, EventEmitter, ViewEncapsulation} from '@angular/core';
import { GetWorkFlowStepByItemDetailForViewDto,WorkFlowStepByItemDetailAction } from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
@Component({
    selector: 'workFlowItemDetail',
    styleUrls: ['./workFlowItem-detail.component.less'],
    templateUrl: './workFlowItem-detail.component.html',
    encapsulation: ViewEncapsulation.None
})
export class WorkFlowItemDetailComponent extends AppComponentBase {

    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();

    active = false;
    saving = false;


    title = '';
    description = '';
    groupDetailByStep = [];
    workFlowStepByItemDetailAction = WorkFlowStepByItemDetailAction;

    constructor(
        injector: Injector
    ) {
        super(injector);
    }
    
    show(listDetail: GetWorkFlowStepByItemDetailForViewDto[],itemTilte?:string): void {
    
        this.title = itemTilte;
        this.groupDetailByStep = [];
        if(!listDetail){
            return;
        }
        for(var i = 0; i < listDetail.length;i++){
            var item = listDetail[i];
            if(this.groupDetailByStep.length ==0){
                this.groupDetailByStep.push({
                    workFlowStepByItemTitle:item.workFlowStepByItemTitle,
                    listDetail:[item]
                });
            } else{
                var lastObj = this.groupDetailByStep[this.groupDetailByStep.length-1]
                if(lastObj.workFlowStepByItemTitle == item.workFlowStepByItemTitle){
                    lastObj.listDetail.push(item);
                } else{
                    this.groupDetailByStep.push({
                        workFlowStepByItemTitle:item.workFlowStepByItemTitle,
                        listDetail:[item]
                    });
                }
            }
        }
        
    }

   
     ngOnInit(): void {
        
     }   
}
